import { Record } from 'immutable'

export interface ICompany {
  id: string
  name: string
}

const CompanyRecord = Record({
  id: '',
  name: '',
})

export class Company extends CompanyRecord {
  public static fromJS(initialState?: Partial<ICompany>) {
    if (!initialState) {
      return new Company()
    }

    const { ...rest } = initialState
    return new Company({
      ...rest,
    })
  }

  public readonly id: string
  public readonly name: string

  constructor(initialState?: Partial<Company>) {
    initialState ? super(initialState) : super()
  }
}
